/* import __COLOCATED_TEMPLATE__ from './category-unread.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./category-unread.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "span",
  classNames: ["category__badges"]
}));